<div class="image-navigation">
  @for (image of images | slice: 0 : 4; track image.url) {
    <img
      [ngSrc]="image.url"
      height="70"
      width="70"
      [alt]="image.alt"
      (click)="onChangeImage(image)"
      [class.active]="image.url === activeImage()?.url"
    />
  }
</div>
@if (activeImage(); as activeImage) {
  <div class="main-image">
    <img [ngSrc]="activeImage.url" height="560" width="560" [alt]="activeImage.alt" />
  </div>
}
